// Module
var code = "<label ng-if=\"$ctrl.isFocused\" class=\"label-wrapper-label\">{{ $ctrl.label }}</label><div ng-transclude></div>";
// Exports
module.exports = code;